import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const AttachIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <mask x="-1.48" y="-0.55" width="25.89" height="25.89" />
      <path d="M10.39,17.79H6.07a5.19,5.19,0,0,1-3.81-1.58A5.19,5.19,0,0,1,.68,12.4,5.2,5.2,0,0,1,2.26,8.58,5.19,5.19,0,0,1,6.07,7h4.32V9.16H6.07A3.21,3.21,0,0,0,2.84,12.4a3.21,3.21,0,0,0,3.23,3.23h4.32ZM7.15,13.47V11.32h8.63v2.15Zm5.39,4.32V15.63h4.32A3.23,3.23,0,0,0,20.1,12.4a3.14,3.14,0,0,0-1-2.3,3.11,3.11,0,0,0-2.29-.94H12.54V7h4.32a5.38,5.38,0,0,1,5.39,5.4,5.38,5.38,0,0,1-5.39,5.39Z" />
    </SvgIcon>
  )
}
export default AttachIcon
